import { Redirect, useParams } from "wouter";
import { useAuth } from "@/hooks/use-auth";

export function useEmailExpress2Enabled() {
  const { user, isLoading } = useAuth();
  return {
    enabled: user?.isMaster === true,
    isUnknown: isLoading,
  };
}

export function EmailExpress2Guard({ children }: { children: React.ReactNode }) {
  const { brandId } = useParams<{ brandId?: string }>();
  const { enabled, isUnknown } = useEmailExpress2Enabled();

  if (isUnknown) return null;
  if (!brandId || !enabled) return <Redirect to={brandId ? `/brands/${brandId}` : "/"} />;
  return <>{children}</>;
}